var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "reopen-replay-modal" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            title: _vm.$t("customerService.re_open_ticket"),
            visible: _vm.dialogUploadVisible,
            width: "500px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogUploadVisible = $event
            },
            close: _vm.handleDialogClose,
            open: _vm.handleDialogOpen,
          },
        },
        [
          _c("div", { staticClass: "header-line" }),
          _c(
            "div",
            { staticClass: "content" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    "label-width": "170px",
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              key: _vm.form.operation_type,
                              attrs: {
                                label: _vm.$t("customerService.reply") + ":",
                                prop: "conclusion",
                                required: "",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "input-conclusion",
                                staticStyle: {
                                  width: "430px",
                                  "min-height": "60px",
                                },
                                attrs: {
                                  size: "small",
                                  placeholder: "Enter your message here",
                                  type: "textarea",
                                  clearable: "",
                                  maxlength: 250,
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.form.conclusion,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "conclusion", $$v)
                                  },
                                  expression: "form.conclusion",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { display: "flex" },
                          attrs: { span: 24 },
                        },
                        [
                          _c("div", { staticClass: "upload-label" }, [
                            _c("span", { staticClass: "upload-label-text" }, [
                              _vm._v(
                                _vm._s(_vm.$t("customerService.attachments"))
                              ),
                            ]),
                          ]),
                          _c(
                            "el-upload",
                            {
                              class: {
                                hideUploadFlag: _vm.isHideAttachmentUpdate,
                                "upload-image": true,
                              },
                              attrs: {
                                action: "#",
                                "auto-upload": false,
                                "file-list": _vm.form.attachmentList,
                                limit: 3,
                                "on-change": _vm.handleAttachmentChange,
                                "on-exceed": _vm.handleExceed,
                                "on-remove": _vm.handleAttachmentRemove,
                                disabled: _vm.uploadAttachmentLoading,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "upload-file-defaule",
                                  attrs: {
                                    slot: "default",
                                    loading: _vm.uploadAttachmentLoading,
                                  },
                                  slot: "default",
                                },
                                [_vm._v("Click here to attach file")]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "dialog-footer" },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-submit",
                  attrs: {
                    type: "info",
                    disabled: _vm.submitLoading || _vm.uploadAttachmentLoading,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onClickSubmitBtn("form")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("components.submit")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogImageVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogImageVisible = $event
            },
          },
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }